export default __webpack_public_path__ + "static/media/login-page.45735eae.png";